import { graphql, navigate } from 'gatsby'
import HomePage from 'components/HomePage/HomePage'
import useQueryString from 'utils/useQueryString'
import { useAppSelector } from 'store/hooks'
import React, { ReactElement, useLayoutEffect } from 'react'
import { getDocumentHead } from 'components/DocumentHead'
import { CONTROLDText } from 'ui/CONTROLD'
import { useLocation } from '@reach/router'

export const fluidImage = graphql`
  fragment FluidImage on File {
    childImageSharp {
      gatsbyImageData(quality: 100, placeholder: NONE, layout: FULL_WIDTH)
    }
  }
`

export const pageQuery = graphql`
  query HomePage {
    customRulesDesktop: file(relativePath: { eq: "homePage/screenshots/cr-desktop@2x.png" }) {
      ...FluidImage
    }
    customRulesMobile: file(relativePath: { eq: "homePage/screenshots/cr-mobile@2x.png" }) {
      ...FluidImage
    }
    customRulesTablet: file(relativePath: { eq: "homePage/screenshots/cr-tablet@2x.png" }) {
      ...FluidImage
    }
    filtersDesktop: file(relativePath: { eq: "homePage/screenshots/filters-desktop@2x.png" }) {
      ...FluidImage
    }
    filtersMobile: file(relativePath: { eq: "homePage/screenshots/filters-mobile@2x.png" }) {
      ...fluidImage
    }
    filtersTablet: file(relativePath: { eq: "homePage/screenshots/filters-tablet@2x.png" }) {
      ...FluidImage
    }
    globalProxyDesktop: file(relativePath: { eq: "homePage/screenshots/gp-desktop@2x.png" }) {
      ...FluidImage
    }
    globalProxyMobile: file(relativePath: { eq: "homePage/screenshots/gp-mobile@2x.png" }) {
      ...FluidImage
    }
    globalProxyTablet: file(relativePath: { eq: "homePage/screenshots/gp-tablet@2x.png" }) {
      ...FluidImage
    }
    schedulesDesktop: file(relativePath: { eq: "homePage/screenshots/schedules-desktop@2x.png" }) {
      ...FluidImage
    }
    schedulesMobile: file(relativePath: { eq: "homePage/screenshots/schedules-mobile@2x.png" }) {
      ...FluidImage
    }
    schedulesTablet: file(relativePath: { eq: "homePage/screenshots/schedules-tablet@2x.png" }) {
      ...FluidImage
    }
    servicesDesktop: file(relativePath: { eq: "homePage/screenshots/services-desktop@2x.png" }) {
      ...FluidImage
    }
    servicesMobile: file(relativePath: { eq: "homePage/screenshots/services-mobile@2x.png" }) {
      ...FluidImage
    }
    servicesTablet: file(relativePath: { eq: "homePage/screenshots/services-tablet@2x.png" }) {
      ...FluidImage
    }
    blockAdsAndTracking: file(
      relativePath: { eq: "homePage/useCases/block-ads-and-tracking.png" }
    ) {
      ...FluidImage
    }
    blockUnwantedContent: file(
      relativePath: { eq: "homePage/useCases/block-unwanted-content.png" }
    ) {
      ...FluidImage
    }
    bypassCensorshipAndGeoblocking: file(
      relativePath: { eq: "homePage/useCases/bypass-censorship-and-geoblocking.png" }
    ) {
      ...FluidImage
    }
    beMoreProductive: file(relativePath: { eq: "homePage/useCases/be-more-productive.png" }) {
      ...FluidImage
    }
  }
`

const HomePageWrapper = (): ReactElement | null => {
  const { qs } = useQueryString()
  const isLoggedIn = useAppSelector(s => s.persistData.sessionToken)
  const location = useLocation()
  useLayoutEffect(() => {
    // Logged in users should be redirected from the homepage to the dashboard
    if (isLoggedIn && !qs.noRedirect && location.hash === '') {
      navigate('/dashboard/profiles')
    }
  }, [isLoggedIn, location.hash, qs.noRedirect])

  return isLoggedIn && !qs.noRedirect && location.hash === '' ? null : <HomePage />
}
export default HomePageWrapper

export const Head = getDocumentHead({
  title: `${CONTROLDText} - Control Your Internet`,
  shouldAugmentTitle: false,
})
